import React, { useState, useEffect, useCallback } from 'react';
import { getBirthdaysToday } from '../api/apiClient';
import socket from '../socket';
import './BirthdayCard.css';

const BirthdayCard = () => {
  const [people, setPeople] = useState([]);

  const fetchBirthdays = useCallback(async () => {
    try {
      const res = await getBirthdaysToday();
      setPeople(Array.isArray(res.data) ? res.data : []);
    } catch {}
  }, []);

  useEffect(() => {
    fetchBirthdays();
    socket.on('staff:changed', fetchBirthdays);
    return () => socket.off('staff:changed', fetchBirthdays);
  }, [fetchBirthdays]);

  if (!people.length) return null;

  const formatNames = (list) => {
    if (list.length === 1) return <><strong>{list[0].name}</strong></>;
    if (list.length === 2) return <><strong>{list[0].name}</strong> and <strong>{list[1].name}</strong></>;
    return <>
      {list.slice(0, -1).map((p, i) => <React.Fragment key={p.id}><strong>{p.name}</strong>{', '}</React.Fragment>)}
      and <strong>{list[list.length - 1].name}</strong>
    </>;
  };

  return (
    <div className="bday-card">
      <span className="bday-icon">🎂</span>
      <p className="bday-text">
        Happy Birthday to {formatNames(people)}!
      </p>
    </div>
  );
};

export default BirthdayCard;
